import { useEffect, useState } from "react";
import { getUnreadMessagesCountByUser } from "../../../../services/messageServices";

export const useUnreadMessages = (user) => {
  const [unreadMessages, setUnreadMessages] = useState(0);

  useEffect(() => {
    if (!user) {
      setUnreadMessages(0);
      return undefined;
    }

    let cancelled = false;

    const refreshUnreadMessages = async () => {
      try {
        const count = await getUnreadMessagesCountByUser();

        if (!cancelled) {
          setUnreadMessages(Number(count || 0));
        }
      } catch (error) {
        console.error("Erreur unread messages:", error);

        if (!cancelled) {
          setUnreadMessages(0);
        }
      }
    };

    refreshUnreadMessages();

    const interval = setInterval(refreshUnreadMessages, 30000);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [user]);

  return unreadMessages;
};